import type {WorkSummary} from 'api/types';
import type {TypedSchema} from 'schemaDefinition/types';
import {mainTitlesPart} from './manifestationSchema';
import {workDataSchema} from './workSchema';

/**
 * Work schema extended with parts from expression and manifestation,
 * .i.e. mainTitles
 */

export const workSummarySchema: TypedSchema<WorkSummary> = {
  name: 'workSummary',
  parts: [
    ...workDataSchema.parts,
    mainTitlesPart,
    {
      type: 'year',
      name: 'publishedYear',
      cardinality: 'multiple',
    },
    {
      type: 'thesaurus',
      name: 'themaLabels',
      key: 'themaLabels',
      cardinality: 'multiple',
      thesaurusId: 'thema',
      showCode: false,
    },
    {
      type: 'text',
      name: 'themaCodes',
      key: 'themaCodes',
      cardinality: 'multiple',
    },
    {
      type: 'schema',
      name: 'otherTitlesType36',
      parts: [
        [
          {
            type: 'text',
            name: 'value',
            key: 'otherTitlesType36.value',
            required: true,
          },
          {
            type: 'codelist',
            name: 'type',
            key: 'otherTitlesType36.type',
            codelistId: 'WORK_TITLE_TYPE',
            required: true,
          },
        ],
      ],
      cardinality: 'multiple',
    },
    {
      type: 'text',
      name: 'otherTitleType36',
      cardinality: 'multiple',
    },
    {
      type: 'text',
      name: 'otherTitleType37',
      cardinality: 'multiple',
    },
  ],
};
